import { useEffect } from 'react';
import { Toast } from '@crehana/compass.ui';
import { CUSTOM_AI } from "../../constants";
import { useUIContext } from "../../context/UI";
import { useTranslation } from "../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
export var WarningNotes = function WarningNotes(_ref) {
  var type = _ref.type,
    isVisible = _ref.isVisible,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUIContext = useUIContext(),
    changeGenerateAI = _useUIContext.changeGenerateAI;
  var contentToast = type === 'error' ? CUSTOM_AI.error : CUSTOM_AI.success;
  useEffect(function () {
    if (isVisible) changeGenerateAI(type === 'error' ? 'custom' : 'successNoteEmpty');
  }, [changeGenerateAI, isVisible, type]);
  return /*#__PURE__*/_jsx(Toast, {
    type: type === 'error' ? 'error' : 'success',
    title: contentToast !== null && contentToast !== void 0 && contentToast.title ? t(contentToast === null || contentToast === void 0 ? void 0 : contentToast.title) : '',
    subtitle: contentToast !== null && contentToast !== void 0 && contentToast.subtitle ? t(contentToast === null || contentToast === void 0 ? void 0 : contentToast.subtitle) : '',
    open: isVisible,
    onClose: onClose
  });
};